(() => {
  const VIEW = 'sitemap-articles';
  const PREVIEW_PARAMS = ['preview_theme_id', 'key', 'pb', '_ab', '_fd', '_sc'];
  const MAX_PAGES = 40;

  const withPreviewParams = (url) => {
    const pageUrl = new URL(window.location.href);
    PREVIEW_PARAMS.forEach((name) => {
      const value = pageUrl.searchParams.get(name);
      if (value) url.searchParams.set(name, value);
    });
    return url;
  };

  const parsePage = (html) => {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const root = doc.querySelector('[data-sitemap-articles-page]');
    if (!root) return { pages: 1, items: [] };

    const pages = Number(root.getAttribute('data-pages')) || 1;
    return {
      pages: Math.min(MAX_PAGES, Math.max(1, pages)),
      items: Array.from(root.querySelectorAll('[data-sitemap-article]')),
    };
  };

  const fetchPage = async (source, page) => {
    const url = withPreviewParams(new URL(source, window.location.origin));
    url.searchParams.set('view', VIEW);
    url.searchParams.set('page', String(page));

    const response = await fetch(url.toString(), {
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
    });
    if (!response.ok) {
      throw new Error(`Failed to load sitemap articles: ${response.status}`);
    }

    return parsePage(await response.text());
  };

  const finish = (list) => {
    list.setAttribute('aria-busy', 'false');
    list.querySelector('[data-sitemap-articles-status]')?.remove();
  };

  const replaceList = (list, items) => {
    const status = list.querySelector('[data-sitemap-articles-status]');
    Array.from(list.querySelectorAll('.custom-sitemap__item')).forEach((item) => {
      if (item !== status) item.remove();
    });
    items.forEach((item) => list.appendChild(document.importNode(item, true)));
    status?.remove();
  };

  const loadList = async (list) => {
    const source = list.getAttribute('data-articles-source');
    if (!source) {
      finish(list);
      return;
    }

    try {
      const first = await fetchPage(source, 1);
      const seen = new Set();
      const items = [];

      const collect = (nodes) => {
        nodes.forEach((node) => {
          const id =
            node.getAttribute('data-article-id') || node.querySelector('a')?.getAttribute('href');
          if (!id || seen.has(id)) return;
          seen.add(id);
          items.push(node);
        });
      };

      collect(first.items);

      if (first.pages > 1) {
        const rest = await Promise.all(
          Array.from({ length: first.pages - 1 }, (_, index) => fetchPage(source, index + 2))
        );
        rest.forEach((pageData) => collect(pageData.items));
      }

      if (items.length) replaceList(list, items);
    } catch (error) {
      console.error(error);
    } finally {
      finish(list);
    }
  };

  const init = () => {
    document.querySelectorAll('[data-sitemap-articles]').forEach((list) => {
      loadList(list);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
